import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Input from "./Input";
import SubmitButton from "./SubmitButton";
import { Message } from "../../locale/Message";
import { changePasswordAction } from "../../actions/Actions";

class ChangePasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      old_password: "",
      new_password: "",
      confirm_password: "",
      isLoading: false,
      error: {},
      successMessage: "",

      showNewPassword: false,
      showConfirmPassword: false,
      showOldPassword: false,
    };
  }

  onInputChange = (event) => {
    const { id, value } = event.target;

    this.setState((prev) => {
      const nextError = { ...prev.error, general: null };

      nextError[id] = null;

      if (id === "new_password" || id === "confirm_password") {
        nextError.confirm_password = null;
      }

      return {
        [id]: value,
        successMessage: "",
        error: nextError,
      };
    });
  };

  validate = () => {
    const { old_password, new_password, confirm_password } = this.state;
    const { lang } = this.props;
    const error = {};

    if (!old_password)
      error.old_password =
        Message.enterPassword?.[lang] || "Введите текущий пароль";
    if (!new_password)
      error.new_password =
        Message.enterNewPassword?.[lang] || "Введите новый пароль";
    if (!confirm_password)
      error.confirm_password =
        Message.repeatNewPassword?.[lang] || "Повторите новый пароль";

    if (new_password && confirm_password && new_password !== confirm_password) {
      error.confirm_password = Message.passwordsNotMatchDetailed[lang];
    }

    return error;
  };

  changePassword = () => {
    const { old_password, new_password } = this.state;
    const { changePassword, lang } = this.props;

    const error = this.validate();
    if (Object.keys(error).length > 0) {
      this.setState({ error });
      return;
    }

    this.setState({ isLoading: true, error: {}, successMessage: "" });

    // API: PUT api/users/password
    changePassword({
      password: old_password,
      value: new_password,
      onSuccess: () => {
        this.setState({
          isLoading: false,
          old_password: "",
          new_password: "",
          confirm_password: "",
          successMessage: Message.passwordChangeSuccess[lang],
          error: {},
        });
      },
      onFailure: (err) => {
        const status = err?.status;
        let general = Message.unknownError[lang];

        if (status === 400) {
          general = Message.passwordInvalidByRequirements[lang];
        }

        if (status === 404 || status === 401 || status === 403) {
          general = Message.passwordWrongCurrent[lang];
        }

        if (status === 502) {
          general = Message.serviceTemporarilyUnavailable[lang];
        }

        this.setState({ isLoading: false, error: { general } });
      },
    });
  };

  render() {
    const {
      old_password,
      new_password,
      confirm_password,
      isLoading,
      error,
      successMessage,
      showNewPassword,
      showConfirmPassword,
      showOldPassword,
    } = this.state;

    const { lang } = this.props;

    return (
      <div>
        {/* 1) Current password Line */}
        <Input
          className="password"
          label={Message.yourPassword?.[lang] || "Ваш пароль"}
          type={showOldPassword ? "text" : "password"}
          value={old_password}
          id="old_password"
          placeholder={
            Message.enterCurrentPassword?.[lang] || "Введите текущий пароль"
          }
          error={error.old_password}
          onInputChange={this.onInputChange}
          rightIcon={{
            icon: showOldPassword ? "fa-eye-slash" : "fa-eye",
            ariaLabel: showOldPassword ? "Скрыть пароль" : "Показать пароль",
            onClick: () =>
              this.setState((p) => ({ showOldPassword: !p.showOldPassword })),
          }}
        />

        {/* 2) New Password Line */}
        <Input
          className="password"
          label={Message.yourNewPassword?.[lang] || "Ваш новый пароль"}
          type={showNewPassword ? "text" : "password"}
          value={new_password}
          id="new_password"
          placeholder={
            Message.enterNewPassword?.[lang] || "Введите новый пароль"
          }
          error={error.new_password}
          onInputChange={this.onInputChange}
          rightIcon={{
            icon: showNewPassword ? "fa-eye-slash" : "fa-eye",
            ariaLabel: showNewPassword ? "Скрыть пароль" : "Показать пароль",
            onClick: () =>
              this.setState((p) => ({ showNewPassword: !p.showNewPassword })),
          }}
        />

        {/* системное сообщение под полем "Ваш новый пароль" */}
        <div className="mb-2">
          <small className="text-muted">
            {Message.passwordRequirements[lang]}
          </small>
        </div>

        {/* 3) Repeat New Password Line */}
        <Input
          className="password"
          label={
            Message.repeatNewPassword?.[lang] || "Повторите ваш новый пароль"
          }
          type={showConfirmPassword ? "text" : "password"}
          value={confirm_password}
          id="confirm_password"
          placeholder={
            Message.repeatNewPassword?.[lang] || "Повторите новый пароль"
          }
          error={error.confirm_password}
          onInputChange={this.onInputChange}
          rightIcon={{
            icon: showConfirmPassword ? "fa-eye-slash" : "fa-eye",
            ariaLabel: showConfirmPassword
              ? "Скрыть пароль"
              : "Показать пароль",
            onClick: () =>
              this.setState((p) => ({
                showConfirmPassword: !p.showConfirmPassword,
              })),
          }}
        />

        {successMessage && (
          <div
            className="alert alert-success"
            role="alert"
            style={{ marginTop: 8 }}
          >
            {successMessage}
          </div>
        )}

        <SubmitButton
          error={error.general}
          onSubmit={this.changePassword}
          isLoading={isLoading}
          text={Message.save?.[lang] || "Сохранить"}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    lang: state.lang,
  }),
  (dispatch) => ({
    changePassword: bindActionCreators(changePasswordAction, dispatch),
  }),
)(ChangePasswordForm);
